import { useQuery } from "@tanstack/react-query";

import { type ChartInterval, getConstructionProgress } from "@/adapters/api";
import { chartKeys } from "../utils/query-keys.ts";

const STALE_TIME = 60_000;

export interface UseConstructionProgressParams {
	constructionId: string | undefined;
	referenceDate: string;
	interval?: ChartInterval;
	stageId?: string;
	enabled?: boolean;
}

export function useConstructionProgress({
	constructionId,
	referenceDate,
	interval = "monthly",
	stageId,
	enabled = true,
}: UseConstructionProgressParams) {
	return useQuery({
		queryKey: chartKeys.progress(
			constructionId,
			referenceDate,
			interval,
			stageId,
		),
		queryFn: () =>
			// biome-ignore lint/style/noNonNullAssertion: guarded by `enabled`
			getConstructionProgress(constructionId!, {
				interval,
				referenceDate,
				stageId,
			}),
		enabled: enabled && !!constructionId,
		staleTime: STALE_TIME,
	});
}
